import { SeverityLevel } from '@microsoft/applicationinsights-web';
import { appInsights } from './appInsights';

const formatArgsForAI = (args: any[]): string => {
  return args
    .map((arg) => {
      if (typeof arg === 'string') return arg;
      if (arg instanceof Error) {
        return `${arg.name}: ${arg.message}\n${arg.stack}`;
      }
      try {
        return JSON.stringify(arg, null, 2);
      } catch (e) {
        return '[Unserializable object]';
      }
    })
    .join(' ');
};

const logger = {
  debug: (...args: any[]) => {
    console.debug(...args);
    if (process.env.NODE_ENV !== 'development') {
      appInsights.trackTrace({
        message: formatArgsForAI(args),
        severityLevel: SeverityLevel.Verbose,
      });
    }
  },
  info: (...args: any[]) => {
    console.info(...args);
    if (process.env.NODE_ENV !== 'development') {
      appInsights.trackTrace({
        message: formatArgsForAI(args),
        severityLevel: SeverityLevel.Information,
      });
    }
  },
  warn: (...args: any[]) => {
    console.warn(...args);
    if (process.env.NODE_ENV !== 'development') {
      appInsights.trackTrace({
        message: formatArgsForAI(args),
        severityLevel: SeverityLevel.Warning,
      });
    }
  },
  error: (...args: any[]) => {
    console.error(...args);
    if (process.env.NODE_ENV !== 'development') {
      const error =
        args.find((arg) => arg instanceof Error) ||
        new Error(formatArgsForAI(args));
      const additionalInfo = args.filter((arg) => !(arg instanceof Error));
      const properties =
        additionalInfo.length > 0
          ? {
              additionalInfo: formatArgsForAI(additionalInfo),
            }
          : undefined;

      appInsights.trackException({
        exception: error,
        properties,
        severityLevel: SeverityLevel.Error,
      });
    }
  },
  log: (...args: any[]) => {
    console.log(...args);
    if (process.env.NODE_ENV !== 'development') {
      appInsights.trackTrace({
        message: formatArgsForAI(args),
        severityLevel: SeverityLevel.Information,
      });
    }
  },
};

export default logger;
